export { default as Loader } from './Loader';
export type { LoaderProps } from './Loader';
